<template>
  <div class="uploader clearfix">
    <div v-if="type == 'video'">
      <input
        type="file"
        ref="fileInput"
        accept="video/*"
        @change="handleVideoChanged"
        style="display: none"
        multiple
      />
      <div class="add item no-boder" @click="handlePickFile">
        <img src="../../assets/img/img_video.png" alt="" />
      </div>
      <transition-group name="uploader-item" tag="div">
        <uploader-item
          class="item"
          v-for="(video, index) in videos"
          :key="video.key"
          :index="index"
          :videos="video"
          :type="'video'"
          @view="openUrl"
          @delete="handleDelete(index)"
          @top="handleTop(index)"
        ></uploader-item>
      </transition-group>
    </div>
    <div v-else>
      <input
        type="file"
        ref="fileInput"
        accept="image/*"
        @change="handleFileChanged"
        style="display: none"
        multiple
      />
      <div class="add item" @click="handlePickFile" v-if="images.length < max">
        <img src="../../assets/img/img_uploader_photo.png" alt="" />
      </div>
      <transition-group name="uploader-item" tag="div">
        <uploader-item
          class="item"
          v-for="(image, index) in images"
          :key="image.key"
          :index="index"
          :images="image"
          :type="'images'"
          @view="openUrl"
          @delete="handleDelete(index)"
          @top="handleTop(index)"
        ></uploader-item>
      </transition-group>
    </div>
  </div>
</template>

<script>
import UploaderItem from "./UploaderItem";
export default {
  name: "Uploader",
  props: {
    max: { type: Number, default: 3 },
    urls: Array,
    videoUrl: String,
    type: String
  },
  data() {
    let images = [];
    let videos = [];
    if (this.urls) {
      images = this.urls.map((url, i) => {
        const formatUrl = this.$api.formatImageUrl(url);
        return {
          origin: url,
          src: formatUrl,
          state: "success",
          progress: 1,
          url: formatUrl,
          key: Date.now() * 100 + i
        };
      });
    } else {
      images = [];
    }
    if (this.videoUrl) {
      const formatVideoUrl = this.$api.formatVideoUrl(this.videoUrl);
      videos.push({
        origin: url,
        src: formatVideoUrl,
        state: "success",
        progress: 1,
        url: formatVideoUrl,
        key: Date.now() * 100
      });
    } else {
      videos = [];
    }
    return {
      images,
      videos,
      isUploading: false
    };
  },
  methods: {
    reloadData() {
      let images = [];
      if (this.urls) {
        images = this.urls.map((url, i) => {
          const formatUrl = this.$api.formatImageUrl(url);
          return {
            origin: url,
            src: formatUrl,
            state: "success",
            progress: 1,
            url: formatUrl,
            key: Date.now() * 100 + i
          };
        });
      } else {
        images = [];
      }
      this.images = images;
    },
    reloadVideosData() {
      let videos = [];
      if (this.videoUrl) {
        const formatVideoUrl = this.$api.formatVideoUrl(this.videoUrl);
        videos.push({
          origin: this.videoUrl,
          src: formatVideoUrl,
          state: "success",
          progress: 1,
          url: formatVideoUrl,
          key: Date.now() * 100
        });
      } else {
        videos = [];
      }
      this.videos = videos;
    },
    handlePickFile() {
      this.$refs.fileInput.click();
    },
    handleFileChanged(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const filename = file.name;
        if (filename.lastIndexOf(".") <= 0) {
          continue;
        }
        let image = {
          file,
          name: filename,
          src: null,
          state: "wait",
          progress: 0.0,
          url: null,
          key: Date.now() * 100 + i
        };
        const fileReader = new FileReader();
        fileReader.onload = function(e) {
          image.src = this.result;
        };
        fileReader.readAsDataURL(file);
        this.images.push(image);
      }
      event.target.value = "";
      this.$emit("change", this.images);
      this.startUpload();
    },
    handleVideoChanged(event) {
      const file = event.target.files[0];
      const filename = file.name;
      var video = {
        file,
        name: filename,
        src: null,
        state: "wait",
        progress: 0.0,
        url: null,
        key: Date.now() * 100
      };
      const fileReader = new FileReader();
      fileReader.onload = function(e) {
        video.src = this.result;
      };
      fileReader.readAsDataURL(file);
      this.videos = [video];

      event.target.value = "";
      this.$emit("change", this.videos);
      this.videoUpload();
    },
    handleDelete(index) {
      if (this.type == "video") {
        this.videos.splice(index, 1);
        this.$emit("change", this.videos);
      } else {
        this.images.splice(index, 1);
        this.$emit("change", this.images);
      }
    },
    handleTop(index) {
      if (this.type == "video") {
        var video = this.videos[index];
        this.videos.splice(index, 1);
        this.videos.unshift(video);
        this.$emit("top", this.videos);
      } else {
        var image = this.images[index];
        this.images.splice(index, 1);
        this.images.unshift(image);
        this.$emit("top", this.images);
      }
    },
    openUrl(url) {
      if (url) {
        if (this.type == "video") {
          window.open(this.$api.formatVideoUrl(url));
        } else {
          window.open(this.$api.formatImageUrl(url));
        }
      }
    },
    handleClear() {
      if (this.type == "video") {
        this.videos = [];
        this.$emit("change", this.videos);
      } else {
        this.images = [];
        this.$emit("change", this.images);
      }
    },
    startUpload() {
      if (this.isUploading) return;
      const image = this.images.find(item => item.state === "wait");
      if (image === undefined) return;

      this.isUploading = true;
      image.state = "uploading";

      this.$api.system
        .uploadImgFile(image.file, {}, progressEvent => {
          image.progress = progressEvent.loaded / progressEvent.total;
        })
        .then(res => {
          image.state = "success";
          image.url = res.data.DefaultUrl;
          this.isUploading = false;
          this.$emit("change", this.images);
          this.startUpload();
        })
        .catch(() => {
          image.state = "fail";
          this.isUploading = false;
          this.$emit("change", this.images);
          this.startUpload();
        });
    },
    videoUpload() {
      if (this.isUploading) return;
      const video = this.videos.find(item => item.state === "wait");
      if (video === undefined) return;

      this.isUploading = true;
      video.state = "uploading";

      this.$api.system
        .uploadVideoFile(video.file, {}, progressEvent => {
          video.progress = progressEvent.loaded / progressEvent.total;
        })
        .then(res => {
          video.state = "success";
          video.url = res.data.DefaultUrl;
          this.isUploading = false;
          this.$emit("change", this.videos);
        })
        .catch(() => {
          video.state = "fail";
          this.isUploading = false;
          this.$emit("change", this.videos);
        });
    }
  },
  components: { UploaderItem }
};
</script>

<style lang="scss" scoped>
.uploader {
  .no-boder {
    border: none !important;
  }
  & .item {
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border: 2px dashed #eee;
    overflow: hidden;
    transition: all 0.3s;

    &.add {
      cursor: pointer;
      & > img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.uploader-item-enter,
.uploader-item-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
